// extracted by mini-css-extract-plugin
export default {"poster":"poster___Y3OHg"};